/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Home_Offerhover_Reviews1Inputs */

const id_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} ulasan`)
};

const ms_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} ulasan`)
};

const da_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} anmeldelser`)
};

const de_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} Bewertungen`)
};

const en_us2_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} reviews`)
};

const es_es2_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} reseñas`)
};

const es_mx2_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} reseñas`)
};

const fil_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} review`)
};

const fr_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} avis`)
};

const it_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} recensioni`)
};

const hu_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} értékelés`)
};

const nl_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} reviews`)
};

const no_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} omtaler`)
};

const pl_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} recenzji`)
};

const pt_br2_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• Avaliações de ${i?.count}`)
};

const pt_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} avaliações`)
};

const ro_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} recenzii`)
};

const fi_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} arvostelua`)
};

const sv_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} recensioner`)
};

const vi_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} đánh giá`)
};

const tr_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} yorum`)
};

const cs_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} recenzí`)
};

const bg_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} ревюта`)
};

const ru_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} обзоров`)
};

const uk_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} відгуків`)
};

const ar_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} مراجعة`)
};

const hi_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} समीक्षाएँ`)
};

const th_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} รีวิว`)
};

const ja_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} レビュー`)
};

const zh_cn2_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} 条评论`)
};

const zh_hant1_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count} 條評論`)
};

const ko_home_offerhover_reviews1 = /** @type {(inputs: Home_Offerhover_Reviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• ${i?.count}개의 리뷰`)
};

/**
* | output |
* | --- |
* | "• {count} reviews" |
*
* @param {Home_Offerhover_Reviews1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_offerhover_reviews1 = /** @type {((inputs: Home_Offerhover_Reviews1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Offerhover_Reviews1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_offerhover_reviews1(inputs)
	if (locale === "ms") return ms_home_offerhover_reviews1(inputs)
	if (locale === "da") return da_home_offerhover_reviews1(inputs)
	if (locale === "de") return de_home_offerhover_reviews1(inputs)
	if (locale === "en-US") return en_us2_home_offerhover_reviews1(inputs)
	if (locale === "es-ES") return es_es2_home_offerhover_reviews1(inputs)
	if (locale === "es-MX") return es_mx2_home_offerhover_reviews1(inputs)
	if (locale === "fil") return fil_home_offerhover_reviews1(inputs)
	if (locale === "fr") return fr_home_offerhover_reviews1(inputs)
	if (locale === "it") return it_home_offerhover_reviews1(inputs)
	if (locale === "hu") return hu_home_offerhover_reviews1(inputs)
	if (locale === "nl") return nl_home_offerhover_reviews1(inputs)
	if (locale === "no") return no_home_offerhover_reviews1(inputs)
	if (locale === "pl") return pl_home_offerhover_reviews1(inputs)
	if (locale === "pt-BR") return pt_br2_home_offerhover_reviews1(inputs)
	if (locale === "pt") return pt_home_offerhover_reviews1(inputs)
	if (locale === "ro") return ro_home_offerhover_reviews1(inputs)
	if (locale === "fi") return fi_home_offerhover_reviews1(inputs)
	if (locale === "sv") return sv_home_offerhover_reviews1(inputs)
	if (locale === "vi") return vi_home_offerhover_reviews1(inputs)
	if (locale === "tr") return tr_home_offerhover_reviews1(inputs)
	if (locale === "cs") return cs_home_offerhover_reviews1(inputs)
	if (locale === "bg") return bg_home_offerhover_reviews1(inputs)
	if (locale === "ru") return ru_home_offerhover_reviews1(inputs)
	if (locale === "uk") return uk_home_offerhover_reviews1(inputs)
	if (locale === "ar") return ar_home_offerhover_reviews1(inputs)
	if (locale === "hi") return hi_home_offerhover_reviews1(inputs)
	if (locale === "th") return th_home_offerhover_reviews1(inputs)
	if (locale === "ja") return ja_home_offerhover_reviews1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_offerhover_reviews1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_offerhover_reviews1(inputs)
	return ko_home_offerhover_reviews1(inputs)
});
export { home_offerhover_reviews1 as "home.offerHover.reviews" }